export const salePages = {
    tv: {
        existsCustomer: [
            {
                page: 'packagesPage',
                percent: 0
            },
            {
                page: 'loginPage',
                percent: 9
            },
            {
                page: 'viewingOptionPage',
                percent: 18
            },
            {
                page: 'convertersPage',
                percent: 27
            },
            {
                page: 'premiumPackagesPage',
                percent: 36
            },
            {
                page: 'addressPage',
                percent: 45
            },
            {
                page: 'technicianPage',
                percent: 54
            },
            {
                page: 'deliveryAddressPage',
                percent: 63
            },
            {
                page: 'userAddressPage',
                percent: 72
            },
            {
                page: 'emailPage',
                percent: 81
            },
            {
                page: 'summaryPage',
                percent: 90
            },
            {
                page: 'successPage',
                percent: 100
            },
        ],
        newCustomer: [
            {
                page: 'packagesPage',
                percent: 0
            },
            {
                page: 'loginPage',
                percent: 8
            },
            {
                page: 'viewingOptionPage',
                percent: 16
            },
            {
                page: 'otpVerifyCode',
                percent: 24
            },
            {
                page: 'convertersPage',
                percent: 32
            },
            {
                page: 'premiumPackagesPage',
                percent: 40
            },
            {
                page: 'addressPage',
                percent: 48
            },
            {
                page: 'technicianPage',
                percent: 56
            },
            {
                page: 'deliveryAddressPage',
                percent: 64
            },
            {
                page: 'personalInfoPage',
                percent: 72
            },
            {
                page: 'summaryPage',
                percent: 80
            },
            {
                page: 'paymentPage',
                percent: 88
            },
            {
                page: 'successPage',
                percent: 100
            },
        ],
    },
    app: {
        existsCustomer: [
            {
                page: 'packagesPage',
                percent: 0
            },
            {
                page: 'loginPage',
                percent: 16
            },
            {
                page: 'premiumPackagesPage',
                percent: 32
            },
            {
                page: 'userAddressPage',
                percent: 48
            },
            {
                page: 'emailPage',
                percent: 64
            },
            {
                page: 'summaryPage',
                percent: 80
            },
            {
                page: 'successPage',
                percent: 100
            },
        ],
        newCustomer: [
            {
                page: 'packagesPage',
                percent: 0
            },
            {
                page: 'loginPage',
                percent: 14
            },
            {
                page: 'otpVerifyCode',
                percent: 28
            },
            {
                page: 'premiumPackagesPage',
                percent: 42
            },
            {
                page: 'personalInfoPage',
                percent: 56
            },
            {
                page: 'summaryPage',
                percent: 70
            },
            {
                page: 'paymentPage',
                percent: 84
            },
            {
                page: 'successPage',
                percent: 100
            },
        ],
    },
    internet: {
        existsCustomer: [
            {
                page: 'packagesPage',
                percent: 0
            },
            {
                page: 'addressPage',
                percent: 10
            },
            {
                page: 'routerPage',
                percent: 30
            },
            {
                page: 'superWifiPage',
                percent: 40
            },
            {
                page: 'internetCustomerInfoPage',
                percent: 45
            },
            {
                page: 'technicianPage',
                percent: 50
            },
            {
                page: 'internetExistingPaymentPage',
                percent: 80
            },
            {
                page: 'successPage',
                percent: 100
            },
        ],
        newCustomer: [
            {
                page: 'packagesPage',
                percent: 0
            },
            {
                page: 'addressPage',
                percent: 9
            },
            {
                page: 'otpVerifyCode',
                percent: 27
            },
            {
                page: 'routerPage',
                percent: 36
            },
            {
                page: 'superWifiPage',
                percent: 45
            },
            {
                page: 'internetCustomerInfoPage',
                percent: 50
            },
            {
                page: 'technicianPage',
                percent: 54
            },
            {
                page: 'internetExistingPaymentPage',
                percent: 80
            },
            {
                page: 'successPage',
                percent: 100
            },
        ],
    },
    triple: {
        existsCustomer: [
            {
                page: 'packagesPage',
                percent: 0
            },
            {
                page: 'addressPage',
                percent: 8
            },
            {
                page: 'loginPage',
                percent: 16
            },
            {
                page: 'routerPage',
                percent: 24
            },
            {
                page: 'superWifiPage',
                percent: 32
            },
            {
                page: 'convertersPage',
                percent: 40
            },
            {
                page: 'premiumPackagesPage',
                percent: 48
            },
            {
                page: 'technicianPage',
                percent: 56
            },
            {
                page: 'pavingFeePage',
                percent: 64
            },
            {
                page: 'userAddressPage',
                percent: 72
            },
            {
                page: 'emailPage',
                percent: 80
            },
            {
                page: 'summaryPage',
                percent: 88
            },
            {
                page: 'successPage',
                percent: 100
            },
        ],
        newCustomer: [
            {
                page: 'packagesPage',
                percent: 0
            },
            {
                page: 'addressPage',
                percent: 7
            },
            {
                page: 'loginPage',
                percent: 14
            },
            {
                page: 'otpVerifyCode',
                percent: 21
            },
            {
                page: 'routerPage',
                percent: 28
            },
            {
                page: 'superWifiPage',
                percent: 35
            },
            {
                page: 'convertersPage',
                percent: 42
            },
            {
                page: 'premiumPackagesPage',
                percent: 49
            },
            {
                page: 'technicianPage',
                percent: 56
            },
            {
                page: 'pavingFeePage',
                percent: 63
            },
            {
                page: 'personalInfoPage',
                percent: 70
            },
            {
                page: 'summaryPage',
                percent: 77
            },
            {
                page: 'paymentPage',
                percent: 84
            },
            {
                page: 'successPage',
                percent: 100
            },
        ],
    },
    cellular: {
      existsCustomer: [
          {
              page: 'packagesPage',
              percent: 0
          },
          {
              page: 'loginPage',
              percent: 12
          },
          {
              page: 'cellularSettingsPage',
              percent: 24
          },
          {
              page: 'userAddressPage',
              percent: 36
          },
          {
            page: 'DeliveryPage',
            percent: 48
          },
          {
            page: 'emailPage',
            percent: 60
          },
          {
              page: 'summaryPage',
              percent: 72
          },
          {
              page: 'successPage',
              percent: 82
          },
          {
            page: 'cellularChooseLineToActivatePage',
            percent: 100
          }
      ],
      newCustomer: [
          {
              page: 'packagesPage',
              percent: 0
          },
          {
              page: 'loginPage',
              percent: 12
          },
          {
              page: 'cellularSettingsPage',
              percent: 24
          },
          {
              page: 'personalInfoPage',
              percent: 36
          },
          {
            page: 'addressPage',
            percent: 36
          },
          {
            page: 'deliveryPage',
            percent: 48
          },
          {
            page: 'deliveryAddressPage',
            percent: 60
          },
          {
              page: 'summaryPage',
              percent: 72
          },
          {
              page: 'paymentPage',
              percent: 84
          },
          {
              page: 'successPage',
              percent: 94
          },
          {
            page: 'cellularChooseLineToActivatePage',
            percent: 100
          }
      ],
  },
  // Catalog entry only — after package select, saleType switches to the package's real type.
  landline: {
    newCustomer: [
      {
        page: 'packagesPage',
        percent: 0,
      },
    ],
  },
};
